//============================================================================
// Redux
//============================================================================
export enum QuickShipsActions {
  StoreInitialState,

  // QuickShip
  Create,
  Start,
  Stop,
  Print,

  // Item
  ItemAppend,
  ItemRemove,
  ItemOverride,
}
